export const missionPlannerDistancePaths = {
  getDurations: `/mission-planner-distance-api/api/getDurations`,
  getDistances: `/mission-planner-distance-api/api/getDistances`,
} as const;

export const getMissionPlannerDistanceApiUrl = {
  getDurations: () => missionPlannerDistancePaths.getDurations,
  getDistances: () => missionPlannerDistancePaths.getDistances,
};
